export default __webpack_public_path__ + "static/benefitBg-1618d4d33e3c5939a85ffa7e3daa4c59.png";